import { lookupReferenceNoJa } from '../api'
import { checkOlsReferenceNoDuplicate } from '../api/ncs'

export function parseCompanyConfigSettings(company) {
	if (!company?.config_settings) return {}
	try {
		return typeof company.config_settings === 'string'
			? JSON.parse(company.config_settings)
			: company.config_settings
	} catch {
		return {}
	}
}

export function companyEnforcesUniqueReferenceNo(company) {
	const cfg = parseCompanyConfigSettings(company)
	return cfg.enforce_unique_reference_no === true
}

/**
 * When company enforcement is on, checks JA then OLS for an existing reference_no.
 * OLS duplicateCheck always uses the company's default contact api_key.
 * @returns {{ duplicate: boolean, jaMatch: boolean, olsMatch: boolean, checkUnavailable: boolean }}
 */
export async function checkReferenceNoDuplicates({
	referenceNo,
	accessToken,
	company,
	enforced,
}) {
	if (!enforced) {
		return { duplicate: false, jaMatch: false, olsMatch: false, checkUnavailable: false }
	}
	const ref = (referenceNo || '').trim()
	if (!ref) {
		return { duplicate: false, jaMatch: false, olsMatch: false, checkUnavailable: false }
	}

	const ja = await lookupReferenceNoJa(accessToken, ref)
	const jaMatch = ja.enforced === true && ja.exists === true

	try {
		const olsMatch = await checkOlsReferenceNoDuplicate(
			ref,
			company?.contact_user?.api_key ?? null,
		)
		return {
			duplicate: jaMatch || olsMatch,
			jaMatch,
			olsMatch,
			checkUnavailable: false,
		}
	} catch {
		return {
			duplicate: jaMatch,
			jaMatch,
			olsMatch: false,
			checkUnavailable: !jaMatch,
		}
	}
}
